module.exports = __webpack_public_path__ + "img/logo-white.e7f73ea3.png";